import React from 'react';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { Card, CardBody, StatusPill, TableScroll } from '../../PanelComerciales.styles';
import SectionHeader from '../SectionHeader/SectionHeader';
import { Notification, NOTIF_TYPE_LABEL } from '../../PanelComerciales.types';

interface NotificationsTableProps {
    notifications: Notification[];
}

const VARIANT: Record<Notification['type'], 'success' | 'warning' | 'danger' | 'muted'> = {
    info: 'success',
    informative: 'success',
    urgent: 'warning',
    critical: 'danger',
};

const NotificationsTable: React.FC<NotificationsTableProps> = ({ notifications }) => (
    <Card>
        <SectionHeader
            title='Notificaciones del sistema'
            subtitle='Alertas automáticas de metas, capacidad y actividad (solo lectura).'
            icon={<NotificationsActiveOutlinedIcon style={{ color: '#EF4444' }} />}
        />
        <CardBody>
            <TableScroll>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Equipo</th>
                            <th>Mensaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notifications.map((n) => (
                            <tr key={n.id}>
                                <td style={{ whiteSpace: 'nowrap' }}>{n.date}</td>
                                <td>
                                    <StatusPill $variant={VARIANT[n.type]}>
                                        {NOTIF_TYPE_LABEL[n.type]}
                                    </StatusPill>
                                </td>
                                <td>{n.team}</td>
                                <td>{n.message}</td>
                            </tr>
                        ))}
                        {notifications.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: 24, color: '#9CA3AF' }}>
                                    Sin alertas por ahora.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TableScroll>
        </CardBody>
    </Card>
);

export default NotificationsTable;
